module.exports = __webpack_public_path__ + "img/arrow_drop_down_2.593d51b5.svg";